/**
 * impersonateViewModel — les règles pures de la session impersonnée : l'écran d'ouverture
 * (`<ImpersonatePage>`), où elle atterrit, et son bandeau (`<ImpersonationBanner>`).
 *
 * Port littéral de l'ancien `src/auth/ImpersonateScreen.js` (l'état et l'atterrissage) et de
 * l'ancien `common/components/banner/ImpersonationBanner.js` (quand le bandeau se montre).
 */
import { hasRole } from "../../../../../data/utility/ability"
import { type UIImpersonateStatus } from "../../../ui/types"
import { selectAccount } from "../../shared/displayedStudent"

// Le store est en JS non typé : on lit les champs qu'on connaît, sans le décrire en entier.
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

export function impersonateStatus(code: string | null | undefined, failed: boolean): UIImpersonateStatus {
    if (!code) return "invalid"
    return failed ? "expired" : "connecting"
}

export type ImpersonateLanding = { parentMode: boolean; screen?: "parent-home" }

/** Un élève atterrit dans l'espace parent (son accueil), un tuteur sur son propre accueil. */
export function impersonateLanding(user: { roles?: string[] } | null | undefined): ImpersonateLanding {
    return hasRole(user, "student") ? { parentMode: true, screen: "parent-home" } : { parentMode: false }
}

export type ImpersonationBannerViewModel = {
    visible: boolean
    name: string
    exiting: boolean
}

/**
 * Le bandeau se tait pendant l'échange d'un code (`onImpersonateRoute`, et la requête en vol) :
 * l'utilisateur gardé par redux-persist est encore celui de la session d'AVANT jusqu'à la
 * réponse, son nom clignoterait.
 */
export function impersonationBannerViewModel(
    state: ReduxState,
    onImpersonateRoute: boolean
): ImpersonationBannerViewModel {
    const user = selectAccount(state)
    const bootstrapping = !!state?.api?.bootstrapImpersonation?.request
    return {
        visible: !!user?.impersonation && !bootstrapping && !onImpersonateRoute,
        name: [user?.firstname, user?.lastname].filter(Boolean).join(" "),
        exiting: !!state?.api?.exitImpersonation?.request,
    }
}
